import { render, staticRenderFns } from "./PublicLandingPage.vue?vue&type=template&id=1d49fd65&scoped=true"
import script from "./PublicLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicLandingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublicLandingPage.vue?vue&type=style&index=0&id=1d49fd65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49fd65",
  null
  
)

export default component.exports